import React, { memo } from "react";
import "./CareerSaveButton.scss";
import tickIco from "../../assets/tickIco.svg";

const CareerSaveButton = ({
  text,
  variant,
  handleSaveCareer,
  isSaved,
  showLoader = false,
}) => {
  return (
    <button
      type="button"
      className={`career-save-button ${
        variant === "filled"
          ? "career-save-button--filled"
          : "career-save-button--outline"
      }`}
      onClick={handleSaveCareer}
      // disabled={isSaved || showLoader}
    >
      {variant === "outline" && !showLoader && (
        <img src={tickIco} alt="tick icon" />
      )}
      {showLoader ? (
        <span className="career-save-button__loader"></span>
      ) : (
        <span className="career-save-button__text">{text}</span>
      )}
    </button>
  );
};

export default memo(CareerSaveButton);
